var map = {
	"./bulk-edit.mp4": 4825,
	"./customize-label.mp4": 806,
	"./nutrition-label-preview.mp4": 822,
	"pages/features/videos/bulk-edit.mp4": 4825,
	"pages/features/videos/customize-label.mp4": 806,
	"pages/features/videos/nutrition-label-preview.mp4": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2026;